<a href="#maincontent" class="skip-link">{{skipToMainContentLabel}}</a>
<soho-icons *ngIf="!inUpliftTheme"></soho-icons>
<soho-icons-uplift *ngIf="inUpliftTheme"></soho-icons-uplift>
<soho-icons-empty *ngIf="!inUpliftTheme"></soho-icons-empty>
<soho-icons-empty-new *ngIf="inUpliftTheme"></soho-icons-empty-new>

<ng-container *ngIf="menuIsV3; else NotV3">
  <soho-module-nav-container [ngClass]="{'module-nav-container': !hideAppMenu}" data-automation-id="lm-appmenu-application-menu">
    <soho-module-nav
      *ngIf="!hideAppMenu && webAppsLoaded"
      #SohoModuleNav
      [ngClass]="{ 'module-nav': true }"
      [showGuestSection]="!mingleMode && !insideInforGo"
      [displayMode]="moduleNavDisplayMode"
      [filterable]="false"
      [pinSections]="true"
      (displaymodechange)="handleDisplayModeChange($event)"
    >
      <lm-application-menu-v3
        class="module-nav-bar"
        [moduleNavDisplayMode]="moduleNavDisplayMode"
        [asOfDate]="asOfDate"
        [searchString]="searchString"
        [menuSearchMode]="menuSearchMode"
        [menuSpecsByWebApp]="menuSpecsByWebApp"
        [dataSearchResults]="dataSearchResults"
        [reportSearchResults]="reportSearchResults"
        (webAppMenuLoaded)="onWebAppMenuLoaded($event)"
        (menuLoaded)="onMenuLoaded($event)"
        (menuSearched)="onMenuSearched($event)"
        (asOfDateChanged)="onAsOfDateChanged($event)"
        (asOfDateClearedEvent)="onAsOfDateCleared()"
        (menuSearchCleared)="onMenuSearchCleared()"
        (roleSelected)="roleSelected()"
        (sohoModuleNavExpanded)="onExpandSohoModuleNav()"
        (sohoModuleNavCollapsed)="onCollapseSohoModuleNav()"
        (homeClicked)="onHomeClicked()">
      </lm-application-menu-v3>
    </soho-module-nav>
    <!--
    - margin-top - of 60px in maincontent is causing issues when showing th busy indicator. It's causing
      shifting when displaying a formComponent (specifically JobPosting.PostingDisplay). Hard coding to 0px.

    - text - Set to a literal 1 space char so that the default text of the busy indicator won't display.
    - displayDelay - default and minimum is 20 ms.
    - blockUI - set to true to stop input while the busy indicator is active
    - timeToComplete - the maximum amount of time the indicator is up. useful for when the busyindicator.close doesn't
                       get messaged due to an error or something.
    - transparentOverlay - whether or not to display a fully transparent overlay instead of the standard grey semi-transparent overlay.
    - complete - event that is fired when the timeToComplete is done; fires regardless if busyIndicator is programmatically stopped
    -->
    <div soho-busyindicator
         #fullmaincontent
         id="fullmaincontent"
         [ngClass]="{
          'page-container': true,
          'scrollable': useFullPageScrolling,
          'lm-hide-titlebar': hideTitle,
          'viewMoreNav' : showViewMoreNav,
       }"
         [text]="' '"
         [blockUI]="true"
         [displayDelay]="0"
         [transparentOverlay]="true"
         [style.margin-top]="'0px'"
         [timeToComplete]="this.uiLoadingIndicatorTimeout"
         (complete)="onBusyComplete($event)"
    >
      <ng-container *ngIf="!inMingleWidget && !inMingleInbox && !hideTitle && !bannerInRoute && !drillAroundWindow">
        <lm-banner-header
                role="banner"
                [class.lm-sticky-banner]="true"
                (appMenuTriggerEvent)="onAppMenuTriggerEvent()"
                (hasBreadcrumbEvent)="onHasBreadcrumbs($event)"
                (asOfDateChanged)="onAsOfDateChanged($event)"
                (asOfDateCleared)="onAsOfDateCleared()"
                (useFullPageScrolling)="fullPageScrolling($event)"
                [asOfDate]="asOfDate"
                [showArchive]="showArchive"
                (quitArchiveViewEvent)="onQuitArchiveView()">
        </lm-banner-header>
      </ng-container>

      <div #maincontent *ngIf="webAppsLoaded"
           id="maincontent"
           [ngStyle]="{ 'height': onMobile ? 'calc(100% - 50px)' : !inMingleWidget && !inMingleInbox && !hideTitle && !bannerInRoute ? hasHeaderTabs || hasBreadcrumbs ? 'calc(100% - 105px)' : 'calc(100% - 61px)' : '100%' }"
        >
        <router-outlet (activate)="onActivate()"></router-outlet>
      </div>

    </div>
  </soho-module-nav-container>
</ng-container>

<ng-template #NotV3>
  <ng-container *ngIf="menuIsV2">
    <nav soho-application-menu #SohoApplicationMenu
     *ngIf="!hideAppMenu"
     data-automation-id="lm-appmenu-application-menu"
     breakpoint="desktop"
     [isPersonalizable]=applyColorToMenu
     class="has-searchfield"
     [filterable]=false
     [dismissOnClickMobile]=true
     (menuVisibility)="onMenuVisibility($event)"
     (accordionExpand)="onAccordionExpand($event)"
     [openOnLarge]="openOnLarge"
     [style.height]="'100%'"
    >
      <lm-application-menu-v2
        class="lm-application-menu-v2 application-menu-wrapper"
        [asOfDate]="asOfDate"
        [showDeletedRecords]="showDeletedRecords"
        [applyColorToMenu]="applyColorToMenu"
        [visibility]="menuSearchMode ? 'hidden' : 'visible'"
        (webAppMenuLoaded)="onWebAppMenuLoaded($event)"
        (menuLoaded)="onMenuLoaded($event)"
        (menuSearched)="onMenuSearched($event)"
        (asOfDateChanged)="onAsOfDateChanged($event)"
        (asOfDateClearedEvent)="onAsOfDateCleared()"
        (roleSelected)="roleSelected()"
      ></lm-application-menu-v2>
    </nav>
    <nav soho-application-menu *ngIf="menuSearchMode"
       id="application-menu-search-v2"
       data-automation-id="lm-appmenu-application-search-menu"
       #SohoApplicationMenuSearch
       breakpoint="desktop"
       class="has-searchfield"
       [filterable]=false
       [isPersonalizable]=applyColorToMenu
       [dismissOnClickMobile]=true
       (menuVisibility)="onSearchMenuVisibility()"
    >
      <lm-application-menu-search
        [searchString]="searchString"
        [menuSpecsByWebApp]="menuSpecsByWebApp"
        [menuSearchResultsByWebApp]="menuSearchResultsByWebApp"
        [dataSearchResults]="dataSearchResults"
        [reportSearchResults]="reportSearchResults"
        [systemSearchResults]="systemSearchResults"
        [menuItemSearch]="menuItemSearch"
        (menuSearched)="onMenuSearched($event)"
        (systemMenuItemClickEvent)="onSystemMenuItemClick($event)"
        (menuLoaded)="onMenuLoaded($event)"
        (menuSearchCleared)="onMenuSearchCleared()"
      ></lm-application-menu-search>
    </nav>
  </ng-container>

  <ng-container *ngIf="menuIsV1">
    <nav soho-application-menu #SohoApplicationMenu
         *ngIf="!hideAppMenu"
         breakpoint="desktop"
         [isPersonalizable]=applyColorToMenu
         class="has-searchfield"
         [filterable]=false
         [dismissOnClickMobile]=true
         (menuVisibility)="onMenuVisibility($event)"
         (accordionExpand)="onAccordionExpand($event)"
         [openOnLarge]="openOnLarge"
         [style.height]="'100%'"
    >
      <lm-application-menu-v1
              class="application-menu-wrapper"
              [asOfDate]="asOfDate"
              [applyColorToMenu]="applyColorToMenu"
              [visibility]="menuSearchMode ? 'hidden' : 'visible'"
              (webAppMenuLoaded)="onWebAppMenuLoaded($event)"
              (menuLoaded)="onMenuLoaded($event)"
              (menuSearched)="onMenuSearched($event)"
              (asOfDateChanged)="onAsOfDateChanged($event)"
              (asOfDateClearedEvent)="onAsOfDateCleared()"
              (roleSelected)="roleSelected()">
      </lm-application-menu-v1>
    </nav>
    <nav soho-application-menu *ngIf="menuSearchMode"
         id="application-menu-search-v1"
         data-automation-id="lm-appmenu-application-search-menu"
         #SohoApplicationMenuSearch
         breakpoint="desktop"
         class="has-searchfield"
         [filterable]=false
         [isPersonalizable]=applyColorToMenu
         [dismissOnClickMobile]=true
         (menuVisibility)="onSearchMenuVisibility()"
    >
      <lm-application-menu-search
              [searchString]="searchString"
              [menuSpecsByWebApp]="menuSpecsByWebApp"
              [menuSearchResultsByWebApp]="menuSearchResultsByWebApp"
              [dataSearchResults]="dataSearchResults"
              [reportSearchResults]="reportSearchResults"
              [systemSearchResults]="systemSearchResults"
              [menuItemSearch]="menuItemSearch"
              (menuSearched)="onMenuSearched($event)"
              (systemMenuItemClickEvent)="onSystemMenuItemClick($event)"
              (menuLoaded)="onMenuLoaded($event)"
              (menuSearchCleared)="onMenuSearchCleared()"
      ></lm-application-menu-search>
    </nav>
  </ng-container>
  <ng-container *ngTemplateOutlet="MainContent"></ng-container>
</ng-template>

<ng-template #MainContent>
  <!--
    - margin-top - of 60px in maincontent is causing issues when showing th busy indicator. It's causing
      shifting when displaying a formComponent (specifically JobPosting.PostingDisplay). Hard coding to 0px.

    - text - Set to a literal 1 space char so that the default text of the busy indicator won't display.
    - displayDelay - default and minimum is 20 ms.
    - blockUI - set to true to stop input while the busy indicator is active
    - timeToComplete - the maximum amount of time the indicator is up. useful for when the busyindicator.close doesn't
                       get messaged due to an error or something.
    - transparentOverlay - whether or not to display a fully transparent overlay instead of the standard grey semi-transparent overlay.
    - complete - event that is fired when the timeToComplete is done; fires regardless if busyIndicator is programmatically stopped
    -->
  <div soho-busyindicator
       #fullmaincontent
       id="fullmaincontent"
       [ngClass]="{
          'page-container': true,
          'scrollable': useFullPageScrolling,
          'lm-hide-titlebar': hideTitle,
          'viewMoreNav' : showViewMoreNav,
       }"
       [text]="' '"
       [blockUI]="true"
       [displayDelay]="0"
       [transparentOverlay]="true"
       [style.margin-top]="'0px'"
       [timeToComplete]="this.uiLoadingIndicatorTimeout"
       (complete)="onBusyComplete($event)"
  >
    <ng-container *ngIf="!inMingleWidget && !inMingleInbox && !hideTitle && !bannerInRoute && !drillAroundWindow">
      <lm-banner-header
        role="banner"
        [class.lm-sticky-banner]="true"
        (appMenuTriggerEvent)="onAppMenuTriggerEvent()"
        (hasBreadcrumbEvent)="onHasBreadcrumbs($event)"
        (asOfDateChanged)="onAsOfDateChanged($event)"
        (asOfDateCleared)="onAsOfDateCleared()"
        (useFullPageScrolling)="fullPageScrolling($event)"
        [asOfDate]="asOfDate"
        [showArchive]="showArchive"
        (quitArchiveViewEvent)="onQuitArchiveView()">
      </lm-banner-header>
    </ng-container>

    <div #maincontent *ngIf="webAppsLoaded"
        id="maincontent"
        [ngStyle]="{'height': onMobile ? 'calc(100% - 50px)' : !inMingleWidget && !inMingleInbox && !hideTitle && !bannerInRoute ? hasHeaderTabs || hasBreadcrumbs ? 'calc(100% - 105px)' : 'calc(100% - 61px)' : '100%' }"
    >
      <router-outlet (activate)="onActivate()"></router-outlet>
    </div>

  </div>
</ng-template>

<!-- Mingle Start Mode Overlay -->
<ng-container *ngIf="useMingleStartMode && inMingle && !mingleStartModeCompleted">
  <div id="mingleStartModeOverlay" class="startModeOverlay"></div>
</ng-container>

<!-- MINGLE VIEW MORE -->
<lm-view-more *ngIf="showViewMoreNav"></lm-view-more>

<div #dialogPlaceholder id="lmAppComponentDialogPlaceholder" class="lmDialogPlaceholder"></div>